export default __webpack_public_path__ + "static/muhammad-zubair-c5a7a8ee98aacc3b458c88ee1b27758b.jpg";